import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { FormGroup } from 'reactstrap'

import PremiumInput from './premium-input'

import BasicPlanErrorMessages from './basic-plan-error-messages'
import {
  editRegularPremium,
  editRegularTopUp,
  editSumAssured,
  selectModelFactor,
} from 'quick-quote/product-investment/coverage-plan/actions'
import {
  getAvailableModelFactors,
  getRegularPremium,
  getRegularTopUp,
  getSelectedModelFactorID,
  getSumAssured,
} from 'quick-quote/product-investment/coverage-plan/selectors'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'
import { RadioButtonGroup } from 'common-components'
import MESSAGES from 'core/data-model/constants/messages'

export const SpulBasicPlanCalculation = ({
  modelFactors,
  regularPremium,
  selectedModelFactorID,
  editRegularPremium,
  selectModelFactor,
}) => {
  return (
    <div id="basic-plan">
      <div className="content">
        <div className="title-bottom-padding">{MESSAGES.PREMIUM_PROPORTION}</div>

        <FormGroup>
          <label> {MESSAGES.PAYMENT_MODE} </label>
          <RadioButtonGroup
            keyToGetValue="id"
            className="model-factor"
            onChange={selectModelFactor}
            value={selectedModelFactorID}
            options={modelFactors}
          />
        </FormGroup>

        <FormGroup className="coverage-plan-calculation item basic">
          <div>
            <div className="sum-assured-input">
              <div className="label">
                <label>{MESSAGES.SPUL_PREMIUM_LABEL}</label>
              </div>

              <PremiumInput
                id="coverage-regular-premium"
                premium={regularPremium}
                editPremiumAmount={editRegularPremium}
              />
            </div>
            <FormGroup className="has-danger">
              <BasicPlanErrorMessages premiumValue={regularPremium} />
            </FormGroup>
          </div>
        </FormGroup>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  selectedProductCode: getSelectedDisplayProductCode(state),
  modelFactors: getAvailableModelFactors(state),
  sumAssured: getSumAssured(state),
  regularPremium: getRegularPremium(state),
  regularTopUp: getRegularTopUp(state),
  selectedModelFactorID: getSelectedModelFactorID(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectModelFactor: bindActionCreators(selectModelFactor, dispatch),
  editSumAssured: bindActionCreators(editSumAssured, dispatch),
  editRegularPremium: bindActionCreators(editRegularPremium, dispatch),
  editRegularTopUp: bindActionCreators(editRegularTopUp, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SpulBasicPlanCalculation)
